
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PsSetItemDtDialog extends Serenity.Extensions.GridEditorDialog<PsSetItemDtRow> {
        protected getFormKey() { return PsSetItemDtForm.formKey; }
        // protected getIdProperty() { return PsSetItemDtRow.idProperty; }
        protected getLocalTextPrefix() { return PsSetItemDtRow.localTextPrefix; }
        protected getNameProperty() { return PsSetItemDtRow.nameProperty; }
        // protected getService() { return PsSetItemDtService.baseUrl; }
        // protected getDeletePermission() { return PsSetItemDtRow.deletePermission; }
        // protected getInsertPermission() { return PsSetItemDtRow.insertPermission; }
        // protected getUpdatePermission() { return PsSetItemDtRow.updatePermission; }

        protected form = new PsSetItemDtForm(this.idPrefix);
        constructor() {
            super();

            

                this.form.PluCode.changeSelect2(e => {
                    var pludesc = Q.toId(this.form.PluCode.value);
                    if (pludesc != null) {
                        let q = Q.tryFirst(Product.CsPluRow.getLookup().items, x=> x.PluCode == pludesc)
                        if(q != null){
                        this.form.NormalUnitPrice.value = q.SellUnitPrice1 ?? 0;
                        this.form.SetUnitPrice.value = q.SellUnitPrice1?? 0;
                        this.form.Unit.value = q.SellUnit; 
                        this.form.PluDesc.value = q.PluDesc; 
                        this.form.SetPrice.value = this.form.SetUnitPrice.value *this.form.Qty.value;
                        }
                       
                    }
                });

                this.form.Qty.changeSelect2(e => {
                    var pludesc = Q.toId(this.form.PluCode.value);
                    if (pludesc != null) {                       
                        
                        this.form.SetPrice.value = this.form.SetUnitPrice.value *this.form.Qty.value
                        //this.form.SetUnitPrice.value = 
                        
                       
                    }
                });

                this.form.SetUnitPrice.changeSelect2(e => {
                    var pludesc = Q.toId(this.form.PluCode.value);
                    if (pludesc != null) {                       
                        
                        this.form.SetPrice.value = this.form.SetUnitPrice.value *this.form.Qty.value
                        //this.form.SetUnitPrice.value = 
                        
                       
                    }
                });

                this.form.SetPrice.changeSelect2(e => {
                    var pludesc = Q.toId(this.form.PluCode.value);
                    if (pludesc != null) {                       
                        
                        this.form.SetUnitPrice.value = this.form.SetPrice.value /(this.form.Qty.value||1)
                        //this.form.SetUnitPrice.value = 
                        
                       
                    }
                });
            }


        

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);


            let newBtn: Serenity.ToolButton =
            {
                title: "บันทึกและสร้างรายการถัดไป",
                hint: "Save and new",
                separator: false,
                cssClass: "button-saveandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {
                    e.preventDefault();
                    this.saveAndNew();
                }
            };
            buttons.push(newBtn);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            this.save((response) => {
                let ent: PsSetItemDtRow = { PluCode: e.PluCode };
                this.loadEntity(ent);
            });
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();

        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            // var thisId = Q.toId(this.form.Id.value);
            // if (thisId < 0) {
            //     let self = this;
            //     self.toolbar.findButton('button-saveandnew').toggleClass('disabled', true);
            // }
        }
         // protected getCssClass() {
        //     super.getCssClass();
        //     return "fixRight";

        // }
    }
}